<template>
    <div class="Abastecimento-Principal">
        <PageTitle icon="fa fa-car" main="Abastecimentos"
            sub="Abastecimento" />
        <div class="Abastecimento-Principal">
            <b-card no-body>
                <b-tabs>        
                    <b-tab title="Abastecimento" active><AbaLancamentos /></b-tab>                                                                                                                        
                    <b-tab title="Indicadores"><AbastecimentoPainel /></b-tab>                                                                                                                                             
                    <b-tab title="Bomba"></b-tab>                                                                                                                                             
                    <b-tab title="Parâmetro"></b-tab>                                                                                                                                             
                </b-tabs>
            </b-card>
        </div>
    </div>
</template>

<script>
import PageTitle from '../template/PageTitle'
import AbaLancamentos from '../abastecimento/AbastecimentoLancamento.vue'
import AbastecimentoPainel from '../abastecimento/AbastecimentoPainel'
export default {
    name: 'AbastecimentoPrincipal',    
  components: { PageTitle,AbaLancamentos,AbastecimentoPainel}      
}
</script>

<style>

</style>






